export default "/images/ru-room-tour-767.png?be95b0afc18e5a984f9fde7c24f22026";